module.exports = __webpack_public_path__ + "static/media/transparency.309d37ed.png";